module.exports = __webpack_public_path__ + "img/full6-min.d202432d.png";